import { useMemo } from "react";
import usePaginatedApiData from "../../../hooks/usePaginatedApiData";
import { buildPaginationParams } from "../../../utils/pagination";

export default function useMembershipMembersData({
  page,
  pageSize,
  searchTerm,
  filters,
  orderBy,
  orderDirection,
}) {
  const params = useMemo(
    () =>
      buildPaginationParams({
        page,
        pageSize,
        search: searchTerm || undefined,
        status: filters?.status || undefined,
        member_type: filters?.member_type || undefined,
        membership_tier: filters?.membership_tier || undefined,
        sort_by: orderBy,
        sort_dir: orderDirection,
      }),
    [
      page,
      pageSize,
      searchTerm,
      filters?.status,
      filters?.member_type,
      filters?.membership_tier,
      orderBy,
      orderDirection,
    ],
  );

  const {
    data: members,
    totalCount,
    loading,
    error,
    refetch,
    setData,
  } = usePaginatedApiData({
    endpoint: "/membership/members",
    params,
    errorMessage: "Failed to load members",
  });

  return {
    members,
    totalCount,
    loading,
    error,
    refetch,
    setMembers: setData,
  };
}
